import { feedItems } from "@/mocks/heigua";

const tagTone: Record<string, string> = {
  一线速报: "bg-ember-100 text-ember-700",
  商务拆解: "bg-leaf-100 text-leaf-600",
  综艺内幕: "bg-cream-200 text-ink-700",
  圈内关系: "bg-ember-50 text-ember-600 border border-ember-100",
  财经瓜: "bg-leaf-50 text-leaf-600 border border-leaf-100",
};

export default function Feed() {
  return (
    <section id="feed" className="relative bg-cream-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        {/* 标题行 */}
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-ember-600">
              <span className="h-px w-8 bg-ember-500" />
              LIVE FEED
            </p>
            <h2 className="font-serif text-2xl font-bold tracking-tight text-ink-950 md:text-4xl">
              黑屋快讯流
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-ink-600 md:text-base">
              短、快、生的第一现场。内部爆料与独家内幕按时间沉淀成线，越往下越接近最近的风向。
            </p>
          </div>
          <a
            href="#vault"
            className="inline-flex shrink-0 items-center whitespace-nowrap text-sm font-medium text-ember-600 hover:text-ember-700"
          >
            展开完整快讯线
            <i className="ri-arrow-right-line ml-1.5" />
          </a>
        </div>

        {/* 时间线 */}
        <div className="relative mt-12 md:mt-16">
          <span className="absolute left-2.5 top-0 h-full w-px bg-cream-200 md:left-3" />
          <div className="flex flex-col gap-8">
            {feedItems.map((item, i) => (
              <article key={i} className="relative pl-12 md:pl-16">
                <span className="absolute left-0 top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-cream-50 ring-2 ring-ember-500 md:h-7 md:w-7">
                  <span className="h-2 w-2 rounded-full bg-ember-500" />
                </span>
                <div className="rounded-xl border border-cream-200 bg-white p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-2 text-xs text-ink-400">
                    <span className="whitespace-nowrap font-medium text-ink-600">
                      <i className="ri-time-line mr-1" />
                      {item.time}
                    </span>
                    <span className="text-cream-300">·</span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-fire-fill text-ember-500" />
                      {item.heat}
                    </span>
                    <span className={`ml-auto whitespace-nowrap rounded-md px-2.5 py-1 text-xs font-medium ${tagTone[item.tag]}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="mt-3 text-base font-semibold leading-snug text-ink-950 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-600 md:text-[15px]">{item.excerpt}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}